export const paymentMethodLabel = (paymentMethod) => {
  if (!paymentMethod) return '-';
  if (paymentMethod.type === 'link') {
    return paymentMethod.email
      ? `Stripe Link (${paymentMethod.email})`
      : 'Stripe Link';
  }
  const last4 = paymentMethod.last4 ?? paymentMethod.card?.last4;
  return last4 ? `Card ending in ${last4}` : 'Card';
};
